var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[(!_vm.hasBack)?_c('MyServicesBurgerMenu'):_vm._e(),(_vm.hasBack)?_c('button',{staticClass:"back",on:{"click":function($event){return _vm.$emit('back')}}},[_c('mdi',{attrs:{"chevron-left":""}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }